import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import { BootstrapVue } from "bootstrap-vue";
import vbMsgBox from "bootstrap-vue-msgbox";
import Vuelidate from "vuelidate";
import axios from 'axios'
import VueAxios from 'vue-axios'
import { firestorePlugin } from 'vuefire'
import Loading from 'vue-loading-overlay';

// styles
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/scss/custom.scss";
import 'vue-loading-overlay/dist/vue-loading.css';

Vue.use(BootstrapVue);
Vue.use(vbMsgBox);
Vue.use(Vuelidate);
Vue.use(VueAxios, axios);
Vue.use(require('vue-moment'));
Vue.use(firestorePlugin);
Vue.use(Loading);

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
